import { Link } from "react-router-dom";
import { episodes } from "@/mocks/episodes";
import { characters } from "@/mocks/characters";
import { news } from "@/mocks/news";
import SectionTitle from "@/components/base/SectionTitle";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import EpisodeRangeCards from "@/pages/home/components/EpisodeRangeCards";
import CharacterSpotlight from "@/pages/home/components/CharacterSpotlight";
import LatestNews from "@/pages/home/components/LatestNews";
import QuickNav from "@/pages/home/components/QuickNav";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  const featured = episodes.slice(0, 4);
  const spotlightCharacters = characters.slice(0, 4);
  const latestNews = news.slice(0, 5);

  return (
    <div className="w-full pb-16 md:pb-20">
      <HeroCarousel slides={featured} />

      <div className="w-full px-4 md:px-8 pt-12 md:pt-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          {/* 左侧主内容 */}
          <div className="lg:col-span-2 flex flex-col gap-12">
            <section>
              <SectionTitle
                eyebrow="剧集导航"
                title="剧集分类快捷入口"
                description="按集数区间快速定位想看的剧情段落，点击即可进入对应的剧集列表。"
                action={
                  <Link
                    to="/episodes"
                    className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap transition-colors cursor-pointer"
                  >
                    查看全部
                    <i className="ri-arrow-right-s-line text-lg" />
                  </Link>
                }
              />
              <EpisodeRangeCards />
            </section>

            <section>
              <SectionTitle
                eyebrow="人物图谱"
                title="热门角色介绍"
                description="陈老根、林晓梅、陈建国……认识这些支撑起全剧情感的角色。"
                action={
                  <Link
                    to="/characters"
                    className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap transition-colors cursor-pointer"
                  >
                    全部角色
                    <i className="ri-arrow-right-s-line text-lg" />
                  </Link>
                }
              />
              <CharacterSpotlight characters={spotlightCharacters} />
            </section>
          </div>

          {/* 右侧边栏 */}
          <aside className="lg:col-span-1 flex flex-col gap-8">
            <div className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
                  <i className="ri-flashlight-line text-primary-600" />
                  最新资讯
                </h3>
                <Link
                  to="/news"
                  className="text-xs text-foreground-500 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  更多
                </Link>
              </div>
              <LatestNews items={latestNews} />
            </div>

            <div className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200">
              <h3 className="font-heading font-bold text-lg text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-compass-3-line text-accent-600" />
                快捷导航
              </h3>
              <QuickNav />
            </div>
          </aside>
        </div>
      </div>

      <SiteIntro />
    </div>
  );
}